module.exports = __webpack_public_path__ + "img/logo_.cffcf645.png";